import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PosthogService } from 'src/app/services/posthog.service';

@Component({
  selector: 'app-invest-document-viewfinder',
  templateUrl: './invest-document-viewfinder.component.html',
  styleUrls: ['./invest-document-viewfinder.component.scss'],
})
export class InvestDocumentViewfinderComponent implements OnInit, OnChanges {

  @Output() public prevEvent = new EventEmitter<any>();
  @Output() public goToSignDocuments = new EventEmitter<any>();
  @Input() documents: any;
  @Input() btnList = true;
  @Input() hasBackBtn = true;

  platform: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    private posthogService: PosthogService
  ) { }

  url: string | undefined;
  zoom = 1;
  currentselected = 0;
  readedByTime = false;
  readedByScroll = false;
  numberOfPages: number;
  currentPage: number;

  ngOnInit() {
    this.loadDocuments();
    setTimeout(() => this.readedByTime = true, 30000);
    // this.posthogService.pushEvent('reading_invest_document');
    this.cdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.documents) {
      this.loadDocuments();
    }
  }

  loadDocuments() {
    this.currentPage = 1;
    this.url = undefined;
    this.documents = Array.isArray(this.documents) ? this.documents : [];
    for (let i = 0; i < this.documents.length; i++) {
      const document = this.documents[i];
      const documentUrl = document?.url || document?.file?.url || document?.files?.[0]?.url;
      document['url'] = documentUrl;
      if (i === 0) {
        this.url = documentUrl;
        this.documents[i]['selected'] = true;
      } else {
        this.documents[i]['selected'] = false;
      }
      this.documents[i]['id'] = i;
    }
  }

  selectDocument(id) {
    if (!this.documents || this.documents.length === 0) {
      return;
    }
    for (let i = 0; i < this.documents.length; i++) {
      if (i === id) {
        this.url = this.documents[i].url;
        this.documents[i]['selected'] = true;
      } else {
        this.documents[i]['selected'] = false;
      }
    }
    this.cdRef.detectChanges();
  }

  next() {
    this.goToSignDocuments.emit();
    this.sendPosthogEvent();
    this.cdRef.detectChanges();
  }

  prev() {
    this.prevEvent.emit();
    this.sendPosthogEvent();
    this.cdRef.detectChanges();
  }

  pageChange(value) {
    this.currentPage = value.pageNumber;
    if (value.pageNumber > 6) {
      this.readedByScroll = true;
    }
    this.cdRef.detectChanges();
  }

  sendPosthogEvent() {
    if (this.readedByTime && this.readedByScroll) {
      // Ha leido los documentos
      // this.posthogService.pushEvent('finish_readed_invest_document');
    } else {
      // No ha leido los documentos
      // this.posthogService.pushEvent('finish_no_readed_invest_document');
    }
    this.cdRef.detectChanges();
  }

  getNumberOfPages(pages) {
    this.numberOfPages = pages;
    this.cdRef.detectChanges();
  }

}
